import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const AUTH_ERROR = {
  ANONYMOUS_ACCESS_DENIED: "anonymous_access_denied",
  ANONYMOUS_USER_NO_LONGER_ANONYMOUS: "anonymous_user_no_longer_anonymous",
};

export const authErrorSchema = z.object({
  error: z.enum([AUTH_ERROR.ANONYMOUS_ACCESS_DENIED, AUTH_ERROR.ANONYMOUS_USER_NO_LONGER_ANONYMOUS]),
  message: z.string(),
});

export const anonymousUserConversionErrorSchema = z.object({
  error: z.enum([AUTH_ERROR.ANONYMOUS_USER_NO_LONGER_ANONYMOUS]),
  message: z.string(),
  provider: z.enum(["email", "github", "google", "linkedin", "openid"]),
});

export class AuthErrorDto extends createZodDto(authErrorSchema) {}
export class AnonymousUserConversionErrorDto extends createZodDto(anonymousUserConversionErrorSchema) {}
